export const ENUM_EMAIL_TEMPLATE_LEGENDS = {
  '{PL_NAME}': 'Project Leader Name',
  '{PROJECT_ACCOUNT_CODE}': 'Project Account Code',
  '{PROJECT_CODE}': 'Project Code',
  '{PROJECT_TITLE}': 'Project Title',
  '{SYSTEM_URL}': 'Dedicated URL to the project profile',
  '{CHANGES_INCLUDED}': 'Team member or leadership change / Budget plan change',
  '{WORK_PROGRAMME}': 'Work Programme',
  '{NEW_STATUS}': 'New project status',
  '{APPROVER_ROLE}': "Approver's role",
  '{APPROVER_NAME}': "Approver's name",
  '{COMMENTS}': 'Comments',
  '{REPORT_SCHEDULE_DATE}': 'Report schedule submission date',
  '{REPORT_TYPE}': 'Report type',
  '{VIREMENT_AMOUNT}': 'Virement Amount',
  '{VIREMENT_FORM}': 'Original Budget Category',
  '{VIREMENT_TO}': 'To Budget Category',
  '{VIREMENT_THRESHOLD}': 'Threshold that require approval for virement',
  '{TYPE_OF_APPLY}': 'Type of application',
  '{APPROVED_APP_DEADLINE_DATE}': 'Deadline of Using Up Funding',
  '{FSLTC_CHAIR_ROLE}': 'F/SLTC Chair',
  '{ANNUAL_REPORT_SCHEDULE_DATE}': 'Annual Report schedule submission date',
  '{FACULTY_SCHOOL_NAME}': 'Faculty/School name',
  '{PROPOSED_PL_NAME}': 'Proposed PL name',
  '{FUNDING_TITLE}': 'Funding title',
  '{END_DATE_APPLICATION_PERIOD}': 'Application period deadline',
  '{APPLICATION_REF_NUMBER}': 'Application reference number',
};
